const MarketplaceAgencyFaq = () => {
  return (
    <>
      <section className="ma-faq bg-light-subtle pt-200 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="d-inline-block px-4 py-1 rounded-pill border border-warning mb-3">
                <p className="ma-warning-text fw-bold mb-0">What we do</p>
              </div>
              <h2 className="ail-title text-black fs-48 fw-600">
                Frequently Asked Question
              </h2>
            </div>
          </div>
          <div className="mt-40">
            <div className="row g-4">
              <div className="col-lg-3">
                <ul
                  className="nav flex-column nav-pills ca-tab"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="v-pills-1-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-1"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-1"
                      aria-selected="true"
                    >
                      About Us
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="v-pills-2-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-2"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-2"
                      aria-selected="false"
                    >
                      Expertise
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="v-pills-3-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-3"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-3"
                      aria-selected="false"
                    >
                      Our Clients
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="v-pills-4-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-4"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-4"
                      aria-selected="false"
                    >
                      Costs & Payments
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="v-pills-5-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#v-pills-5"
                      type="button"
                      role="tab"
                      aria-controls="v-pills-5"
                      aria-selected="false"
                    >
                      Our Process
                    </button>
                  </li>
                </ul>
              </div>
              <div className="col-lg-7">
                <div className="tab-content" id="v-pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="v-pills-1"
                    role="tabpanel"
                    aria-labelledby="v-pills-1-tab"
                  >
                    <div className="d-flex flex-column gap-5">
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          Where are You Based?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How do you handle differences in time zones?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How Big is your company?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-pills-2"
                    role="tabpanel"
                    aria-labelledby="v-pills-2-tab"
                  >
                    <div className="d-flex flex-column gap-5">
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          Where are You Based?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How do you handle differences in time zones?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How Big is your company?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-pills-3"
                    role="tabpanel"
                    aria-labelledby="v-pills-3-tab"
                  >
                    <div className="d-flex flex-column gap-5">
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          Where are You Based?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How do you handle differences in time zones?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How Big is your company?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-pills-4"
                    role="tabpanel"
                    aria-labelledby="v-pills-4-tab"
                  >
                    <div className="d-flex flex-column gap-5">
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          Where are You Based?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How do you handle differences in time zones?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How Big is your company?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-pills-5"
                    role="tabpanel"
                    aria-labelledby="v-pills-5-tab"
                  >
                    <div className="d-flex flex-column gap-5">
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          Where are You Based?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="border-bottom pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How do you handle differences in time zones?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                      <div className="pb-4">
                        <h6 className="text-black fw-semibold mb-3">
                          How Big is your company?
                        </h6>
                        <p className="mb-0">
                          While we have companies registered in USA, UAE and the
                          UK, our main design and development force is
                          distributed across Eastern Europe and CIS region. This
                          way, we are able to charge less & provide our clients
                          with a great cost-effective ratio while keeping the
                          quality high.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MarketplaceAgencyFaq;
